export const styles = () => ({
  container: {
    height: 200,
    boxShadow:
      '0px 0px 1px rgba(0, 0, 0, 0.08),0px 2px 2px rgba(0, 0, 0, 0.04),0px 1px 2px rgba(0, 0, 0, 0.04)',
    borderWidth: 2,
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: 6,
    overflow: 'hidden',
  },
  textContainer: {
    flexDirection: 'column' as const,
    width: '92%',
    display: 'flex',
    padding: 20,
    justifyContent: 'space-around',
  },
  tickContainer: {
    height: '100%',
    flex: 1,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '8%',
  },
  tick: {
    color: 'white',
    height: '3.8rem',
    width: '3.8rem',
    lineHeight: 0,
    marginRight: 1,
  },
  etaContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
})
